<div class="form-floating">
  <select
    id="select-country"
    class="form-select"
    [class.invalid]="!control?.valid && control?.touched"
    name="Country"
    (change)="writeValue($event.target.value)"
  >
    <option value="" selected hidden>
      {{ 'country.options.none.selected' | translate: { fgbdefault: '--Select--' } }}
    </option>
    <option *ngFor="let country of countries" [value]="country.CountryName" [selected]="country.CountryName === innerValue">
      {{ country.DisplayName }}
    </option>
  </select>
  <label for="select-country" *ngIf="label">{{ label }}</label>
</div>
